// @ts-expect-error: TS7006
export function composeEvent<T extends (...args) => void>(...funcs: (T | null | undefined)[]): T {
  return ((...args) => {
    funcs.forEach((func) => func?.(...args));
  }) as T;
}

export function composeRef<T>(...refs: (React.Ref<T> | null | undefined)[]): React.RefCallback<T> {
  return (node: T) => {
    refs.forEach((ref) => {
      if (ref == null) return;
      if (typeof ref === 'function') {
        ref(node);
      } else {
        (ref as React.MutableRefObject<T>).current = node;
      }
    });
  };
}
